import {lighten} from 'polished';
import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {Table} from 'components/ui-kit/Table';
import {breakpoint, colors} from 'theme';

export const UserStatusTag = styled.div<{isActive: boolean}>`
    padding: 7px 10px;
    font-size: 11px;
    font-weight: 500;
    border-radius: 4px;
    color: ${(p) => (p.isActive ? colors.success : colors.danger)};
    background-color: ${(p) =>
        p.isActive ? lighten(0.36, colors.success) : lighten(0.25, colors.danger)};
    cursor: default;
    white-space: nowrap;
`;

export const CustomTable = styled(Table)`
    margin-top: -40px;
`;

export const CreateOrganizationButton = styled(Button)`
    color: ${colors.brandPrimary};
    text-decoration: none;
    width: auto;
    align-self: flex-start;
    margin-top: 10px;
    margin-left: -20px;

    > span {
        padding: 0 20px;
    }

    @media (min-width: ${breakpoint.phone}) {
        margin-top: 0;
        margin-left: 0;
    }
`;

export const BalanceCell = styled.div`
    width: 100%;
    min-width: 100px;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
`;
